<template>
  <!-- //NOSONAR -->
  <li class="slider__slide" :style="{ padding: `0 ${this.padding}px` }" :aria-current="current">
    <slot/>
  </li>
</template>

<script>
  export default {
    name: 'slide-item',
    props: {
      current: { type: Boolean, required: false }
    },
    data() {
      return {
        width: null,
        padding: this.$parent.slidePadding
      };
    },
  };
</script>
